<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="分配承运商"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="承运商" prop="partnershipId">
        <el-select
          v-model="formData.partnershipId"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in carrierOption"
            :key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId"
            v-show="item.partnershipType !== 3"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { amountReg } from "@/hooks/regex";
import {
  getPartnerManagementBond,
  savePartnerAllocateRegion,
} from "@/api/oldForNew";

export default {
  components: {},

  data() {
    return {
      id: "",
      dialogFormVisible: false,
      carrierOption: [], //承运商选项列表
      carrierOptionObj: {},
      formData: {
        provinceName: "",
        provinceCode: "",
        cityName: "",
        cityCode: "",
        partnershipId: "",
        partnerName: "",
      },
      rules: {
        partnershipId: [
          { required: true, message: "请选择承运商", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请输入初始金额", trigger: "blur" },
          {
            pattern: amountReg,
            trigger: "blur",
            message: "请输入金额，不超过100,000,000，最多两位小数",
          },
        ],
      },
      btnLoading: false,
    };
  },
  watch: {
    dialogFormVisible: function (val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    },
  },
  async created() {
    this.getPartnerList();
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(rowData) {
      this.formData.partnershipId = null;
      let {
        provinceName,
        provinceCode,
        cityName,
        cityCode,
        partnershipId,
        partnerName,
      } = rowData;

      this.formData = {
        provinceName,
        provinceCode,
        cityName,
        cityCode,
        partnershipId,
        partnerName,
      };

      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存和编辑数据接口
    async save() {
      this.formData.partnerName =
        this.carrierOptionObj[this.formData.partnershipId];
      let { statusCode, message } = await savePartnerAllocateRegion(
        this.formData
      );
      if (statusCode == 200) {
        this.$message.success("保存成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartnerManagementBond();
      if (statusCode == 200) {
        this.carrierOption = data;
        console.log("this.carrierOption ", this.carrierOption);
        //转成对象用于返显示
        this.carrierOptionObj = this.carrierOption.reduce((obj, item) => {
          obj[item.partnershipId] = item.partnerName;
          return obj;
        }, {});
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/setCarrierDialog.vue